import { BOOKING_URL } from '../constants';
import { useMotion } from '../lib/motion';

const ABOUT_IMAGE = "/salao.jpg";

export default function About() {
  const scope = useMotion();

  return (
    <section ref={scope} id="sobre" data-testid="about-section" className="bg-raised border-y border-rule">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 items-center">
        <div data-media className="md:col-span-5 overflow-hidden rounded-2xl">
          <img
            src={ABOUT_IMAGE}
            alt="Recepção do salão com o mural Nyjuliabraids em grafite"
            loading="lazy"
            width="960"
            height="1280"
            className="w-full aspect-[4/5] object-cover"
            data-testid="about-image"
          />
        </div>

        <div className="md:col-span-6 md:col-start-7">
          <h2 data-lines className="text-4xl md:text-5xl font-extrabold tracking-tight leading-none text-ink mb-6">
            Um salão onde todo mundo é bem-vindo
          </h2>
          <div data-rise="0.2" className="space-y-4 text-soft leading-relaxed max-w-[55ch] mb-8">
            <p>
              A Nyjuliabraids nasceu do empreendedorismo feminino e do amor pela arte das tranças afro-brasileiras.
            </p>
            <p>
              Atendemos cabelo crespo e cacheado, virgem ou com química, e couro cabeludo sensível. Mulheres, homens e a comunidade LGBTQ+ têm lugar garantido aqui.
            </p>
          </div>
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-rise="0.35"
            data-magnetic
            className="inline-flex items-center bg-ink text-paper px-8 py-4 rounded-full text-base font-semibold whitespace-nowrap hover:bg-tan transition-colors"
            data-testid="about-booking-btn"
          >
            Agendar horário
          </a>
        </div>
      </div>
    </section>
  );
}
